export default __webpack_public_path__ + "static/media/community-button.27a0d3b9.svg";